import React, { useState } from "react";
import { Button, DatePicker, message } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { useFiltrationModel } from "../filtrationModel";
import moment from "moment";
import { globalPrompt } from "@/components/message";
import { filtrationService } from "../filtrationService";
const { RangePicker } = DatePicker;

export const DataBox = () => {
	const { searchParamTime, searchParam, setSearchParamTime, loadData, selectedRowKeys, setSelectedRowKeys } = useFiltrationModel();

	//查询条件
	const rightChildren = <div className="flex">
		<RangePicker
			placeholder={["截止开始日期", "截止结束日期"]}
			className="ant-picker-round mr-10"
			format={"YYYY-MM-DD"}
			value={!searchParamTime.startTime || !searchParamTime.endTime ? null : [moment(searchParamTime.startTime), moment(searchParamTime.endTime)]}
			onChange={(a: any, arr: string[]) => {
				let obj = { ...searchParamTime, startTime: arr[0] ? arr[0] + ' 00:00:00' : "", endTime: arr[1] ? arr[1] + ' 23:59:59' : "" };
				setSearchParamTime(obj);
				loadData({ pageNum: 1 }, searchParam, obj);
			}}
		/>
		<RangePicker
			placeholder={["采集开始日期", "采集结束日期"]}
			className="ant-picker-round mr-10"
			format={"YYYY-MM-DD"}
			value={!searchParamTime.pubStartTime || !searchParamTime.pubEndTime ? null : [moment(searchParamTime.pubStartTime), moment(searchParamTime.pubEndTime)]}
			onChange={(a: any, arr: string[]) => {
				let obj = { ...searchParamTime, pubStartTime: arr[0] ? arr[0] + ' 00:00:00' : "", pubEndTime: arr[1] ? arr[1] + ' 23:59:59' : "" };
				setSearchParamTime(obj);
				loadData({ pageNum: 1 }, searchParam, obj);
			}}
		/>
		<Button
			className="mr-5"
			type="link"
			shape="round"
			onClick={() => loadData({ pageNum: 1 }).then(res => res && message.success("已刷新"))}
		>刷新</Button>
		<Button
			className="mr-5"
			type="link"
			shape="round"
			onClick={() => loadData()}
		>检索</Button>
		<Button
			className="mr-5"
			type="link"
			shape="round"
			onClick={() => {
				if (!selectedRowKeys.length) {
					message.warning("请勾选你要删除的数据");
					return;
				};
				globalPrompt("modal", {
					title: "确认删除？",
					text: "",
					onOk: () => filtrationService.removeAll(selectedRowKeys.map(item => item.id)).then(res => {
						res && loadData();
						setSelectedRowKeys([]);
						message.success("删除成功");
					})
				});
			}}
		>批量删除</Button>
	</div>

	return (
		<YhBox title=" " style={{ marginTop: "20px" }} rightChildren={rightChildren}>
			<DataTable />
		</YhBox>
	)
}